import { CommoditiesServiceMock } from "./commodities.types";

export const mockCommoditiesService = (): CommoditiesServiceMock => ({
  fetchCommodities: jest.fn(),
});
